import { isDevMode, Component, OnInit, EventEmitter, Output } from '@angular/core';

import * as screenfull from 'screenfull';
import { DialogService } from '@wephone-utils';
import { UserCommonSettingsComponent } from '@wephone-app-phone/modals/settings/user-common-settings/user-common-settings';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { Router } from '@angular/router';
import { SoundService } from '@wephone-audio';
import { PhoneService } from '@wephone-app-phone/services';
import { UserEntity } from '@wephone-core/model/entity/user';
import { EnterpriseEntity } from '@wephone-core/model/entity/enterprise';
import { EnterpriseRepository } from '@wephone-core/model/repository/enterprise';

@Component({
  selector: 'phone-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class PhoneHeaderComponent implements OnInit {
  @Output() readonly toggleSidenav = new EventEmitter<void>();
  @Output() readonly toggleNotificationSidenav = new EventEmitter<void>();

  devMode = false;
  loggedUser: UserEntity;
  myenterprise: EnterpriseEntity;

  constructor(
    private dialogService: DialogService,
    private authService: AuthenticationService,
    private router: Router,
    private soundService: SoundService,
    private phoneService: PhoneService
  ) {
    this.devMode = isDevMode();
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.getUser() as UserEntity;
    this.myenterprise = (EnterpriseRepository.getInstance() as EnterpriseRepository).getMyEnterprise();
  }

  fullScreenToggle(): void {
    if (screenfull && screenfull.enabled) {
      screenfull.toggle();
    }
  }

  openPageSettings(): void {
    this.dialogService.openDialog2(UserCommonSettingsComponent, {});
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate([ '/s/signin' ]);
    // window.location.reload(false);
  }

  isPlayerVisible(): boolean {
    return this.soundService.isTopPlayerVisible();
  }

  phoneEngineReady(): boolean {
    return this.phoneService.isReady();
  }
}
